/**
 * Mail-Security Fixture — Live-Shape von Nexus.
 * Spec: lmm-wiki/wiki/orbit-specs/done/nexus-mail-security-overview.md
 *
 * Felder mirrorn das echte Nexus-Backend (Audit OBS-1, 2026-06-14):
 *   account_id (nicht account), bimi_bytes (nicht bimi_logo_bytes),
 *   algorithm (nicht algo). Der useNexusMailSecurity-Hook normalisiert
 *   beide Richtungen — Snapshot-Tests können künftig auf der Live-Form fahren.
 */

const RECORDS = [
  {
    domain: 'example.de',
    tenant_id: 3,
    account_id: 'enhance-org_42',
    dkim_selector: 'mail202606',
    algorithm: 'rsa-2048',
    dmarc_policy: 'quarantine',
    spf: 'v=spf1 include:_spf.valitype.com -all',
    dmarc: 'v=DMARC1; p=quarantine; rua=mailto:dmarc@valitype.com',
    bimi_active: true,
    bimi_logo_url: 'https://bimi.valitype.com/example/logo.svg',
    bimi_bytes: 8421,
    vmc_url: null,
  },
  {
    domain: 'kunde.com',
    tenant_id: 3,
    account_id: 'enhance-org_42',
    dkim_selector: 'mail202604',
    algorithm: 'rsa-2048',
    dmarc_policy: 'none',
    spf: 'v=spf1 include:_spf.valitype.com -all',
    dmarc: 'v=DMARC1; p=none; rua=mailto:dmarc@valitype.com',
    bimi_active: false,
    bimi_logo_url: null,
    bimi_bytes: null,
    vmc_url: null,
  },
];

const HISTORY = {
  'example.de': [
    { selector: 'mail202606', algorithm: 'rsa-2048', created_at: '2026-06-14T03:14:00Z', status: 'active' },
    { selector: 'mail202604', algorithm: 'rsa-2048', created_at: '2026-04-01T08:00:00Z', status: 'rotated_at_2026-06-14' },
    { selector: 'mail202602', algorithm: 'rsa-1024', created_at: '2026-02-01T08:00:00Z', status: 'rotated_at_2026-04-01' },
  ],
};

export function mailSecurityListFixture({ domainFilter = '', tenantId = '' } = {}) {
  let list = RECORDS;
  if (domainFilter) list = list.filter((r) => r.domain.includes(domainFilter));
  if (tenantId) list = list.filter((r) => String(r.tenant_id) === String(tenantId));
  return { records: list };
}

export function mailSecurityDetailFixture(domain) {
  const r = RECORDS.find((x) => x.domain === domain);
  if (!r) return null;
  // Nexus liefert Detail als `{ record, dkim_history }`-Wrapper —
  // der Hook entpackt das, hier mirrorn wir es.
  return {
    record: r,
    dkim_history: HISTORY[domain] ?? [
      { selector: r.dkim_selector, algorithm: r.algorithm, created_at: null, status: 'active' },
    ],
  };
}

export function mailSecurityPreviewFixture(domain) {
  const r = RECORDS.find((x) => x.domain === domain);
  // Nexus liefert das echte Preview-Schema mit `suggestions` als Object-Array
  // (name/level/message), nicht das ehemalige record/from/to-Schema. Der Hook
  // mappt name→record, level→state. Wir spiegeln die Backend-Form hier.
  return {
    state: r?.dmarc_policy === 'quarantine' ? 'ok' : 'drift',
    dns_target: domain,
    operations: [
      { action: 'update', kind: 'TXT', name: '_dmarc.' + domain, value: 'v=DMARC1; p=quarantine', id: null },
      { action: 'create', kind: 'TXT', name: 'default._bimi.' + domain, value: 'v=BIMI1; l=…', id: null },
    ],
    suggestions: [
      { name: 'spf', level: 'ok' },
      { name: 'dmarc', level: 'drift', message: 'p=none → p=quarantine' },
      { name: 'dkim', level: 'ok' },
      { name: 'bimi', level: 'missing' },
    ],
    records: {
      spf: r?.spf,
      dmarc: r?.dmarc,
      dkim_selector: r?.dkim_selector,
    },
  };
}
